import styles from "./styles.module.css";
import * as React from "react";

const PageNotFound = () => {
    return (
        <div className={styles.container}>
            <div className={styles.box}>
                <span className={styles.message}>404: Sorry, we can't find that page</span>
            </div>
        </div>
    );
};

PageNotFound.propTypes = {
    
};

export default PageNotFound;